import { Box, Typography } from "@mui/material";
import NMSRateOptions from "./NMSRateOptions";
import { TextField } from "@mui/material";

export default function ExclusivePartnerOrbitSendModal({
  agencyPharmacy,
  selectedPartner,
  handleCancel,
  handleSelectPartner,
  agencyRates,
  setNote,
  note,
}) {
  return (
    <>
      {(() => {
        switch (agencyPharmacy?.requestStatusType) {
          case 1:
            return (
              <div className="modal-section">
                <Box>
                  <Typography
                    Typography
                    variant="nms-title-orbit"
                    fontWeight="bold"
                  >
                    Requests
                  </Typography>
                  <div className="nms-to-orbit-option">
                    <div className="nms-to-orbit-option-header">
                      <Typography
                        id="modal-title"
                        variant="h6"
                        sx={{ fontSize: "14px" }}
                      >
                        {selectedPartner?.companyName}
                      </Typography>
                      <span className="nms-request-status-tag">PENDING</span>
                    </div>
                    <div className="nms-text-orbit-wrapper">
                      <Typography className="nms-to-orbit-description">
                        Your request is sent to {
                          selectedPartner?.companyName
                        }
                        for review.
                      </Typography>
                      <NMSRateOptions
                        consentedRate={selectedPartner?.consentedRate}
                        unConsentedRate={selectedPartner?.unConsentedRate}
                      />
                    </div>
                    <button
                      type="submit"
                      className="warn-btn-class"
                      onClick={handleCancel}
                    >
                      
                      Delete
                    </button>
                  </div>
                </Box>
              </div>
            );
          case 2:
            return (
              <div className="modal-section">
                <Box>
                  <Typography
                    Typography
                    variant="nms-title-orbit"
                    fontWeight="bold"
                  >
                   
                    Requests
                  </Typography>
                  <div className="nms-to-orbit-option">
                    <div className="nms-to-orbit-option-header">
                      <Typography
                        id="modal-title"
                        variant="h6"
                        sx={{ fontSize: "14px" }}
                      >
                       
                        {selectedPartner?.companyName}
                      </Typography>
                      <span className="nms-request-status-tag">Approved</span>
                    </div>
                    <div className="nms-text-orbit-wrapper">
                      <Typography className="nms-to-orbit-description">
                      
                        Your request is approved body
                        {selectedPartner?.companyName}
                      </Typography>
                      <NMSRateOptions
                        consentedRate={agencyPharmacy?.nmsConsentedResponseRate}
                        unConsentedRate={
                          agencyPharmacy?.nmsUnconsentedResponseRate
                        }
                      />
                    </div>
                    <button
                      type="submit"
                      className="warn-btn-class"
                      onClick={handleCancel}
                    >
                     
                      Delete
                    </button>
                  </div>
                </Box>
              </div>
            );
          default:
            return (
              <>
                <div className="modal-section">
                  <Typography
                    Typography
                    variant="nms-title-orbit"
                    fontWeight="bold"
                  >
                   
                    Orbit Partners
                  </Typography>
                  <Typography className="nms-to-orbit-description">
                    Our partners have been carefully selected to provide the
                    best outsourcing experience. Once you have selected your
                    partner, they will provide their specific pricing to you.
                  </Typography>

                  {!selectedPartner && (
                    <Typography
                      className="nms-to-orbit-select-partner"
        
                    >
                      Please select a partner to proceed
                    </Typography>
                  )}
                  <div className="nms-to-orbit-options-company">
                    {agencyRates?.map((partner) => (
                      <Box onClick={() => handleSelectPartner(partner)}>
                        <div className="nms-to-orbit-option">
                          <div className="nms-to-orbit-option-header">
                            <Typography
                              id="modal-title"
                              variant="h6"
                              sx={{
                                fontSize: "14px",
                                marginBottom: "15px",
                              }}
                            >
                             
                              {partner?.companyName}
                            </Typography>
                          </div>
                          <div className="nms-text-orbit-wrapper">
                            <Typography className="nms-to-orbit-description">
                              
                              We’re the best rated NMS service in the UK, and we
                              have regional providers for more local.
                            </Typography>
                          </div>
                        </div>
                      </Box>
                    ))}
                  </div>
                </div>
                {selectedPartner && (
                  <>
                    <div className="modal-section">
                      <Box>
                        <Typography
                          Typography
                          variant="nms-title-orbit"
                          fontWeight="bold"
                        >
                          
                          Requests
                        </Typography>
                        <div className="nms-to-orbit-option">
                          <div className="nms-to-orbit-option-header">
                            <Typography
                              id="modal-title"
                              variant="h6"
                              sx={{ fontSize: "14px" }}
                            >
                             
                              {selectedPartner?.companyName}
                            </Typography>
                            <span className="nms-request-status-tag">
                              SEND REQUEST
                            </span>
                          </div>
                          <div className="nms-text-orbit-wrapper">
                            <Typography className="nms-to-orbit-description">
                              
                              Your request will be sent to
                              {selectedPartner?.companyName} for review.
                            </Typography>
                            <NMSRateOptions
                              consentedRate={selectedPartner?.consentedRate}
                              unConsentedRate={selectedPartner?.unConsentedRate}
                            />
                          </div>
                        </div>
                      </Box>
                    </div>

                    <div className="input_wrapper">
                      <div className="input_field">
                        <div>
                          <TextField
                            label="Notes"
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={2}
                            sx={{ marginTop: "10px" }}
                            inputProps={{ maxLength: 500 }}
                            value={note}
                            onChange={(e) => {
                              setNote(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            );
        }
      })()}
    </>
  );
}
